import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Import navigation hook
import '../styles/Settings.css'; // external CSS file

const Settings = () => {
  const [activeSection, setActiveSection] = useState('account'); // Track active section
  const navigate = useNavigate(); // Hook for navigating back

  // Render the content for the selected section
  const renderSection = () => {
    switch (activeSection) {
      case 'account':
        return (
          <div className="settings-content">
            <h2>Account Settings</h2>
            <p>Here you can update your account information, change your password, and manage personal details.</p>
          </div>
        );
      case 'subscriptions':
        return (
          <div className="settings-content">
            <h2>Subscriptions & Billing</h2>
            <p>Manage your subscription plans, view invoices, and update your billing information here.</p>
          </div>
        );
      case 'notifications':
        return (
          <div className="settings-content">
            <h2>Notification Settings</h2>
            <p>Customize your notification preferences for email, SMS, and in-app alerts.</p>
          </div>
        );
      default:
        return <div className="settings-content"><p>Select a section from the menu below.</p></div>;
    }
  };

  return (
    <div className="settings-container">
      {/* Header with Back Button */}
      <header className="settings-header">
        <div className="settings-back-button" onClick={() => navigate('/notebookhome')}>
          ← Back to Home
        </div>
        <h1 className="settings-title">Settings</h1>
      </header>

      {/* Main Content Area */}
      <div className="settings-main-content">
        {renderSection()}
      </div>

      {/* Navigation Bar at the Bottom */}
      <div className="settings-navbar">
        <div
          className={`settings-nav-item ${activeSection === 'account' ? 'settings-active-nav-item' : ''}`}
          onClick={() => setActiveSection('account')}
        >
          Account Settings
        </div>
        <div
          className={`settings-nav-item ${activeSection === 'subscriptions' ? 'settings-active-nav-item' : ''}`}
          onClick={() => setActiveSection('subscriptions')}
        >
          Subscriptions & Billing
        </div>
        <div
          className={`settings-nav-item ${activeSection === 'notifications' ? 'settings-active-nav-item' : ''}`}
          onClick={() => setActiveSection('notifications')}
        >
          Notification Settings
        </div>
      </div>
    </div>
  );
};

export default Settings;
